import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import PrivacyJamb from "./components/PrivacyJamb";
import AdminNotifications from "./components/AdminNotifs";
import AdminManualPay from "./components/AdminManualPay";
import KinteronLanding from "./components/Homepage";
import Reseller from "./components/Reseller";
import Desktop from "./components/Desktop";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<KinteronLanding />} />
        <Route path="/reseller" element={<Reseller />} />
        <Route path="/desktop" element={<Desktop />} />
        <Route path="/dev" element={<Portfolio />} />
        <Route path="/privacyj" element={<PrivacyJamb />} />
        <Route path="/adminnotifshula" element={<AdminNotifications />} />
        <Route path="/adminmanualpay0" element={<AdminManualPay />} />
      </Routes>
    </Router>
  );
}

export default App;
